/** Taille d’un lot de vignettes 3D — borne les contextes WebGL simultanés. */
export const ASSET_PICKER_BATCH_SIZE = 12;

export const ASSET_PICKER_SENTINEL_CLASS = 'asset-picker-sentinel';

export type AssetPickerScrollSentinelHandle = {
  disconnect: () => void;
};

/**
 * Place une sentinelle en bas de `grid` et appelle `onLoadMore` quand elle
 * entre dans la zone de défilement. `root` = conteneur qui défile (défaut =
 * la grille elle-même) — pas la fenêtre, sinon tous les lots se chargeraient
 * d’un coup.
 */
export function attachAssetPickerScrollSentinel(
  grid: HTMLElement,
  hasMore: boolean,
  onLoadMore: () => void,
  root: Element | null = grid
): AssetPickerScrollSentinelHandle {
  let observer: IntersectionObserver | null = null;
  let sentinel: HTMLDivElement | null = null;

  const disconnect = (): void => {
    observer?.disconnect();
    observer = null;
    sentinel?.remove();
    sentinel = null;
  };

  if (!hasMore) return { disconnect };

  sentinel = document.createElement('div');
  sentinel.className = ASSET_PICKER_SENTINEL_CLASS;
  sentinel.setAttribute('aria-hidden', 'true');
  grid.appendChild(sentinel);

  observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) onLoadMore();
    },
    { root, rootMargin: '200px' }
  );
  observer.observe(sentinel);

  return { disconnect };
}
